import { Routes } from '@angular/router';
import { AuthGuardService } from './shared';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'flat-details',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'flat-details',
    loadChildren: () => import('./flat-details/flat-details.module').then(m => m.FlatDetailsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-details',
    loadChildren: () => import('./applicant-details/applicant-details.module').then(m => m.ApplicantDetailsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'documents',
    loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'payment-milestones',
    loadChildren: () => import('./payment-milestones/payment-milestones.module').then(m => m.PaymentMilestonesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'requests',
    loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'updates',
    loadChildren: () => import('./updates/updates.module').then(m => m.UpdatesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'cctv',
    loadChildren: () => import('./cctv/cctv.module').then(m => m.CctvModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'payment-options',
    loadChildren: () => import('./payment-options/payment-options.module').then(m => m.PaymentOptionsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'payment-confirmation',
    loadChildren: () => import('./payment-confirmation/payment-confirmation.module').then(m => m.PaymentConfirmationModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'payment-failure',
    loadChildren: () => import('./payment-failure/payment-failure.module').then(m => m.PaymentFailureModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'payment-history',
    loadChildren: () => import('./payment-history/payment-history.module').then(m => m.PaymentHistoryModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'slot-booking',
    loadChildren: () => import('./slot-booking/slot-booking.module').then(m => m.SlotBookingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'feeds',
    loadChildren: () => import('./feeds/feeds.module').then(m => m.FeedsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'contact',
    loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'customer-communication',
    loadChildren: () => import('./customer-communication/customer-communication.module').then(m => m.CommunicationModule),
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    redirectTo: 'flat-details',
    pathMatch: 'full'
  }
];
